import { lazy, Suspense } from 'react';

import { LoadingBlock } from '../../components/StateBlock';
import type { FeatureRoute } from '../registry';

// Lazy-loaded: the POS is a large, separately used screen; keep it out of the
// admin's initial bundle.
const PosPage = lazy(() => import('./PosPage').then((m) => ({ default: m.PosPage })));
const CustomerViewPage = lazy(() => import('./CustomerViewPage').then((m) => ({ default: m.CustomerViewPage })));

// Authenticated, rendered without the AppShell (legacy /pos and /customer-view).
export const fullscreenRoutes: FeatureRoute[] = [
  {
    path: 'pos',
    element: (
      <Suspense fallback={<LoadingBlock />}>
        <PosPage />
      </Suspense>
    )
  },
  {
    path: 'customer-view',
    element: (
      <Suspense fallback={<LoadingBlock />}>
        <CustomerViewPage />
      </Suspense>
    )
  }
];
